import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class TableService extends HttpService {
	/**
	 * Update table
	 */
	@POST('table/lock')
	@Adapter(null, { isAdmin: false, showResponeMessage: false })
	lockTable(@Body data: string): Observable<any> {
		return null;
	}

	@POST('table/unLock')
	@Adapter(null, { isAdmin: false, showResponeMessage: false })
	unLockTable(@Body data: string): Observable<any> {
		return null;
	}
}
